import isEmpty from 'lodash/isEmpty';

function useBlobUpload() {
  async function setHash(hash, body, progress) {
    if (isEmpty(hash)) return;

    const method  = 'PUT';
    const url     = hash.url;
    const headers = JSON.parse(hash.headers);

    return new Promise(async function(resolve) {

      const xhr = new XMLHttpRequest;
      xhr.open(method, url, true);
      xhr.responseType = "text";

      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }

      xhr.addEventListener("load", event => resolve({ error: false }) );

      if (progress && xhr.upload) {
        xhr.upload.onprogress = function(event) {
          progress(Math.floor(event.loaded * 100 / event.total));
        };
      }

      xhr.addEventListener("error", event => {
        console.error('use-blob-upload-error', { event, method, headers, url })
        resolve({ error: true, response: xhr.response });
      });

      xhr.send(body.slice());
    });
  }

  return [setHash];
}

export default useBlobUpload;
